import EventBus from '@/common/EventBus'
import { mapGetters, mapMutations } from 'vuex'
let audioProcessorManager = null
import store from "@/store";
export default {
  data() {
    return {
      activePlayerFrom: '', // 当前播放的音频消息的来源
      activePlayer: null, // 当前播放的音频消息
      activePlayerVolume: 100, // 当前播放的音频消息的音量
      activePlayerEndCb: null, // 当前播放的音频消息的中断回调
    }
  },
  mounted() { 
    EventBus.$on('SOCKET_SOUND_MESSAGE', this.playSoundMessage)
    EventBus.$on('Play_Laughter', this.handlePlayLaughter)
  },
  beforeDestroy() {
    EventBus.$off('SOCKET_SOUND_MESSAGE', this.playSoundMessage)
    EventBus.$off('Play_Laughter', this.handlePlayLaughter)
  },
  computed: {
    volumeMultiplier() {
      let voice_pack_volume = this.voice_pack_volume
      let voiceLevel = this.setting_data.voiceLevel
      if (this.activePlayerFrom === 'preview') {
        if (!voice_pack_volume) {
          voice_pack_volume = 100
        }
        if (!voiceLevel) {
          voiceLevel = 100
        }
      }
      return (voice_pack_volume * voiceLevel) / 10000
    },
    ...mapGetters([
      'cur_channel_data',
      'voice_pack_volume',
      'user_info',
      'setting_data', 
      'anchor_mute_user_ids',
      'laughter_blacklist',
      'bilibili_living',
      'anchor_mode',
    ])
  },
  watch: {
    'sound_message_active': {
      handler(v) {
        this.SET_SOUND_MESSAGE_ACTIVE(v)
      },
      deep: true
    },
    voice_pack_volume (v) {
      this.handleChangeVolume()
    },
    'setting_data.voiceLevel': {
      handler(v) {
        this.handleChangeVolume()
      }
    }
  },
  methods: {
    async playSoundMessage(s_data) {
      let { data } = s_data
      if (this.laughter_blacklist.includes(+data.user_id)) {
        clientLog('[SOUND_MESSAGE] reject blacklist' ,JSON.stringify(data))
        return
      }
      if (data.channel_id != this.cur_channel_data.channel_id) {
        clientLog('[SOUND_MESSAGE] reject diff channel' ,JSON.stringify(data))
        return
      }
      if (this.cur_channel_data.mute_earphone) {
        clientLog('[SOUND_MESSAGE] reject mute_earphone' ,JSON.stringify(data))
        return
      }
      if (this.play_lock) {
        clientLog('[SOUND_MESSAGE] reject play_lock' ,JSON.stringify(data))
        return
      }
      if (data.user_id != this.user_info.user_id && this.bilibili_living && !data.verified) {
        clientLog('[SOUND_MESSAGE] reject bilibili' ,JSON.stringify(data))
        return
      }

      let audio_url = `https://hf.max-c.com/voice/${data.path}.${data.ext}`
      if (data.user_id == this.user_info.user_id) {
        this.fetchAndPlayMessage(audio_url, data)
      } else {
        // 如果是他人发送的语音消息
        if (this.setting_data.isMuteLaughter) {
          clientLog('[SOUND_MESSAGE] reject isMuteLaughter' ,JSON.stringify(data))
          return
        }
        // 主播模式的静音列表不接收语音包
        if (this.anchor_mode) {
          let anchor_mute_user = this.anchor_mute_user_ids[data.user_id]
          if (anchor_mute_user && !anchor_mute_user.ignore) {
            clientLog('[SOUND_MESSAGE] reject anchor_mute' ,JSON.stringify(data))
            return
          }
        }

        // 获取并播放音频
        this.fetchAndPlayMessage(audio_url, data)
      }
    },
    fetchAndPlayMessage (url, data) {
      this.fetchAudioBuffer(url).then(async (audioBuffer) => {
        const startCb = () => {
          this.SET_SOUND_MESSAGE_ACTIVE({
            [data.user_id]: true
          })
        }
        const endCb = () => {
          this.SET_SOUND_MESSAGE_ACTIVE({
            [data.user_id]: false
          })
        }
        this.handlePlayLaughter({ audioBuffer, volume: data.volume, startCb, endCb })
        clientLog('[SOUND_MESSAGE] play')
      }).catch((err) => {
        console.log('err', err);
        clientLog('[SOUND_MESSAGE] fetchAndPlayMessage error' , err)
        this.$toast.error('播放音频失败')
      })
    },
    
    async stopSoundPlay () {
      if (this.activePlayer) {
        await this.$nextTick()
        this.activePlayer?.source?.stop()
        this.activePlayer = null
        this.activePlayerVolume = 100
        this.activePlayerEndCb && this.activePlayerEndCb()
        this.activePlayerEndCb = null
      }
    },
    async fetchAudioBuffer (url) {
      const response = await fetch(url)
      const arrayBuffer = await response.arrayBuffer()
      await this.ensureAudioProcessorManager()
      return audioProcessorManager.getAudioContext().decodeAudioData(arrayBuffer)
    },
    async handlePlayLaughter({ url, audioBuffer, volume, startTime, from, startCb, endCb }) {
      if (!url && !audioBuffer) return
      await this.ensureAudioProcessorManager()
      if (url && !audioBuffer) {
        try {
          audioBuffer = await this.fetchAudioBuffer(url)
        } catch (e) {
          return
        }
      }
      await this.stopSoundPlay()
      volume = volume || 100
      // 计算音量乘数，基于用户的音量设置
      this.activePlayerFrom = from || ''
      const volumeMultiplier = (volume / 100) * this.volumeMultiplier
      this.activePlayerVolume = volume
      this.activePlayerEndCb = endCb
      const global_config = store.getters.global_config || {}
      // 使用 AudioProcessorManager 获取 AudioProcessor 并处理音频缓冲区
      const processor = audioProcessorManager.getAudioProcessor({
        enableNormalization: global_config.voicePackNormalization,
        targetRMS: global_config.voicePackTargetRms,
        maxGain: global_config.voicePackMaxGain,
      })
      const player = processor.processAudioBuffer(audioBuffer, volumeMultiplier)
      const duration = audioBuffer.duration // 获取音频的持续时间
      let playStartTime = Date.now()
      if (startTime) {
        player.source.start(0, startTime) // 指定开始播放的时间
      } else {
        player.source.start() // 开始播放音频
      }
      player.source.onended = () => {
        if (this.activePlayer === player) {
          const playEndTime = Date.now()
          endCb && endCb(playEndTime - playStartTime)
          this.activePlayer = null
          this.activePlayerEndCb = null
        }
      }
      this.activePlayer = player // 保存当前播放的音频消息
      startCb && startCb(player, duration)
      return { player, duration }
    },
    async ensureAudioProcessorManager() {
      return new Promise((resolve) => {
        if (audioProcessorManager) {
          resolve()
        } else {
          import('_lib/audio/AudioProcessorManager').then((module) => {
            audioProcessorManager = module.default
            resolve()
          })
        }
      })
    },
    handleChangeVolume() {
      if (this.activePlayer) {
        const gainValue = this.activePlayer.normalizationGain * (this.activePlayerVolume / 100) * this.volumeMultiplier
        this.activePlayer.gainNode.gain.value = gainValue
      }
    },
    ...mapMutations([
      'SET_SOUND_MESSAGE_ACTIVE'
    ])
  },
}
